import React, { useState } from 'react';
import VisibilityIcon from '@mui/icons-material/Visibility';
import CustomTh from '../../../components/table/CustomTh';
import CustomTd from '../../../components/table/CustomTd';
import TableFunction from './../../../components/table/TableFunction';
import DropDownMenuProfile from './../../../components/DropDown/DropDownMenuProfile';
import DropDownMenuItem from './../../../components/DropDown/DropDownMenuItem';
import { modelHeaders } from '../Model/ModelHeaders';
import { extractValueForHeader, formatDate } from './Functions';
import { DateKeys } from '../../../enums/datekeys';
import {EMPTY_VALUES} from "../../../Apis/functions";
import {DetailsIconsOptions} from "../../../components/buttons/IconButtons";
import {GetSoftDeletedRecordsByTable} from "../../../reduxToolkit/Commons/CommonsApi";
import {permissionObj} from "../../../Helpers/permission";
import {useDispatch, useSelector} from "react-redux";
/**
 * @Email : sgarcia@ibl.mx
 * @Author: Susana Garcia Rodriguez
 * @jobTittle: Frontend
 * @param data Array The data to be displayed in the table.
 * @param handleOpenModal Function Function to handle opening a modal.
 * @param selectedModel String Model that has been selected for the table structure.
 * @param model Boolean Flag indicating  the model has been provided.
 */
const HardDeleteTableApp = ({ handleOpenModal, selectedModel, selectedList, setSelectedList, modified,
                                setModified, searchElement,  setIsAllChecked}) => {
    let dispatch = useDispatch();
    const [tableId, setTableId] = useState('tbl_hd_delete');
    const [searchId, setSearchId] = useState('txt_hd_delete');
    const [results, setResults] = useState({ content: [], totalElements: 0 });
    const DEV = useSelector((state) => state?.CommonsSlice?.development);
    const { permission } = useSelector((state) => state.authenticatioauthennSlice);
    const deletePermission =  DEV ||
        permission?.includes(permissionObj?.WEB_HARD_DELETE_DELETE) ||
        permission?.includes(permissionObj?.WEB_HARD_DELETE_RECOVER);
    const leftPosition = deletePermission ? 50 : 0;
    // Function to generate the table header
    const getThead = () => {
        let header = [];

        if (modelHeaders[selectedModel]) {
            header = modelHeaders[selectedModel].map((header, index) => {
                const headerKey = header.split('.').pop();
                return (
                    <CustomTh key={header} tableId={tableId} fixedXY={index === 0} left={index === 0 ? leftPosition : undefined}>
                        {t(headerKey).toUpperCase()}
                    </CustomTh>
                );
            });
        }

        return header;
    };

    // Function to generate the table body
    const getTbody = () => {
        if (!results || !results.content) {
            return {
                body: [],
                data: [],
            };
        }


        let body = results.content.map((item) => {
            return (
                <>
                    {modelHeaders[selectedModel]?.map((header, index) => {
                        const value = extractValueForHeader(item, header);

                        const isDateKey = Object.values(DateKeys).includes(header);
                        const formattedValue = isDateKey && typeof value === 'number' ? formatDate(value) : value;

                        return (
                            <CustomTd
                                key={`${item.id}-${header}`}
                                tableId={tableId}
                                fixed={index === 0}
                                left={index === 0 ? leftPosition : undefined}
                            >
                                {formattedValue !== null && formattedValue !== undefined ? formattedValue : EMPTY_VALUES.DEFAULT}
                            </CustomTd>
                        );
                    })}
                </>
            );
        });

        return {
            body: body,
            data: results.content,
        };
    };
    // Function to generate action buttons
    const getActionsButtons = (item, index) => {
        return (
            <>
                <DropDownMenuProfile openMenu={openMenu} handleMenuToggle={handleMenuToggle} menuId={`menu-${item.id}`}>
                    <DropDownMenuItem
                        index={index}
                        handleClose={handleClose}
                        name={t('details')}
                        icon={<DetailsIconsOptions/>}
                        click={() => {
                            handleOpenModal(item);
                        }}
                    />
                </DropDownMenuProfile>
            </>
        );
    };

    /**
     * Executes a paginated search request using basic criteria.
     *
     * Builds the request body with the current page, page size, selected model,
     * and any additional criteria passed as arguments.
     * Triggers the search action through Redux and updates the results on success.
     */
    const getData = (page) => {
        if (selectedModel) {
            const body = {
                option: selectedModel,
                pagination: {
                    page,
                    size: rowsPerPage,
                },
            };

            dispatch(GetSoftDeletedRecordsByTable(body)).then(
                ({
                     payload: {
                         data: { data, success },
                     },
                 }) => {
                    if (success) {
                        setResults(data || { content: [] });
                    }
                },
            );
        }
    }
    // Function to manage table pagination and selection
    const {
        t,
        thead,
        tbody,
        handleCheckboxChange,
        handleDeleteAll,
        openMenu,
        handleMenuToggle,
        handleClose,
        pagination,
        page,
        setPage,
        rowsPerPage,
        setRowsPerPage,
    } = TableFunction({
        data:results,
        getThead,
        getTbody,
        selectedList,
        setSelectedList,
        labelRowsPerPage: 'rows_per_page',
        setIsAllChecked,
        searchElement,//New
        getData,//New
        modified,//New
        setModified,//New
    });

    return {
        tableId,
        searchId,
        thead,
        tbody,
        handleCheckboxChange,
        handleDeleteAll,
        pagination,
        getActionsButtons,
        page,
        setPage,
        rowsPerPage,
        setRowsPerPage,
        results,
        setResults,
        deletePermission
    };
};
export default HardDeleteTableApp;
